import React from 'react'

import { Box, Typography } from "@mui/material"


export default function usersHomeColumn() {

	return {
		name: 'user',
		label: 'User',
		render: value => <Box>
			<Typography>{value}</Typography>
		</Box>,
	}
}